
import axios from "axios";

const ERP_API_URL = process.env.REACT_APP_ERP_API_URL;
const ERP_EMAIL = process.env.REACT_APP_ERP_EMAIL;
const ERP_PASSWORD = process.env.REACT_APP_ERP_PASSWORD;

let erpToken = null;

export const getErpToken = async () => {
    if (erpToken) {
        return erpToken;
    }

    console.log("ERP API URL:", ERP_API_URL);

    if (!ERP_API_URL) {
        throw new Error(
            "REACT_APP_ERP_API_URL is not configured in .env"
        );
    }

    const response = await axios.post(
        `${ERP_API_URL}/Auth/login`,
        {
            email: ERP_EMAIL,
            loginId: "string",
            roleId: "string",
            tui: "string",
            isAdmin: true,
            password: ERP_PASSWORD,
        },
        {
            headers: {
                Accept: "text/plain",
                "Content-Type": "application/json",
            },
        }
    );

    if (!response.data?.token) {
        throw new Error("ERP login failed: token not received");
    }

        erpToken = response.data.token;
    console.log("ERP LOGIN EMAIL:", ERP_EMAIL);
    console.log("ERP PASSWORD SET:", !!ERP_PASSWORD);
    console.log("ERP PASSWORD LENGTH:", ERP_PASSWORD?.length);
        return erpToken;
    
};
